<template>
  <naj-box :title="local.bankruptcy.debtorForm.title">
    <identity-verification-form
      :form-model="formModel"
      :person-title="local.bankruptcy.debtorForm.debtor"
      :view-mode="isIdentityFormDisabled"
      :manager-social-id-required="false"
      @partyTypeChanged="partyTypeChangeHandler"
    ></identity-verification-form>

    <v-row>
      <v-col
        v-if="isFirmOrOrganization"
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.bankruptcy.debtorForm.firmType"
          :value.sync="formModel.firmTypeId"
          :items="firmTypes"
          item-text="name"
          :validates="`required`"
          item-value="id"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.bankruptcy.debtorForm.classification"
          :value.sync="formModel.debtorClassificationId"
          :items="partyTypeDebtorClassifications[formModel.typeId]"
          item-text="name"
          :validates="`required`"
          item-value="id"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.debtorForm.region"
          :value.sync="formModel.region"
          :validates="`required|max:100`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.debtorForm.city"
          :value.sync="formModel.city"
          :validates="`required|max:100`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.debtorForm.headquarter"
          :value.sync="formModel.headquarter"
          :validates="`required|max:100`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>

      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          v-mask="'05########'"
          :type-id="formFieldType.text"
          :label="local.bankruptcy.debtorForm.mobile"
          :value.sync="formModel.mobile"
          :validates="`digits:10`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.debtorForm.email"
          :value.sync="formModel.email"
          :validates="`email|no_gov_email`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          v-mask="'##########'"
          :type-id="formFieldType.text"
          :label="local.bankruptcy.debtorForm.phone"
          :value.sync="formModel.phone"
          :validates="`max:10|min:10`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.isOrganizedEntity"
          :items="yesNoOptions"
          item-value="id"
          item-text="name"
          :label="local.bankruptcy.debtorForm.isOrganizedEntity"
          :validates="`required`"
          :disabled="isViewMode || isCompetentParty || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
          @change="isOrganizedEntityChangeHandler"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.isOrganizedEntity"
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.selectbox"
          :label="local.bankruptcy.debtorForm.organizedType"
          :value.sync="formModel.organizedEntityTypeId"
          :items="organizedEntityTypes"
          item-text="name"
          :validates="`required`"
          item-value="id"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
          @change="organizedEntityTypeChangeHandler"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.isOrganizedEntity && formModel.organizedEntityTypeId==organizedEntityTypesEnum.other"
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.debtorForm.otherOrganizedType"
          :value.sync="formModel.otherOrganizedEntityType"
          :validates="`required|max:100`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
    </v-row>

    <v-row v-if="formModel.isOrganizedEntity">
      <v-col
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.isSpecifiedOrganization"
          :items="yesNoOptions"
          item-value="id"
          item-text="name"
          :label="local.bankruptcy.debtorForm.isSpecifiedOrganization"
          :disabled="isViewMode || isCompetentParty || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
          @change="isSpecifiedOrganizationChangeHandler"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.isSpecifiedOrganization"
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.text"
          :label="local.bankruptcy.debtorForm.specifiedOrganizationName"
          :value.sync="formModel.specifiedOrganizationName"
          :validates="`required|max:100`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
      <v-col
        v-if="formModel.isSpecifiedOrganization"
        cols="12"
        md="6"
        lg="3"
      >
        <naj-input
          :type-id="formFieldType.number"
          :label="local.bankruptcy.debtorForm.specifiedOrganizationUnifiedNumber"
          :value.sync="formModel.specifiedOrganizationUnifiedNumber"
          :validates="`long|max:15|min:3|isValid:${local.bankruptcy.debtorForm.invalidNumber},${isNumberValid}`"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && isNotCompleted)"
        ></naj-input>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.bankruptDetailsConfirmation"></audit-confirmation-flag-checkbox>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <naj-input
          :type-id="formFieldType.textarea"
          :label="bankruptcyProofs"
          :value.sync="formModel.bankruptcyProofs"
          :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.proofBankruptcyConfirmation}`] && isNotCompleted)"
          validates="required"
        ></naj-input>
        <audit-confirmation-flag-checkbox :audit-flag="mainRequestAuditFlag.proofBankruptcyConfirmation"></audit-confirmation-flag-checkbox>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { partyTypeEnum, organizedEntityTypesEnum, requestOwnerTypeEnum, mainRequestAuditFlag, requestStatusEnum, procedureTypeEnum } from '@/modules/bankruptcy/helpers/enum';

const { mapState, mapGetters, mapActions, mapState: mapLUTState } = createNamespacedHelpers('BankruptcyModule');
import IdentityVerificationForm from '@/modules/bankruptcy/components/request/identity-verification-form.vue';
import AuditConfirmationFlagCheckbox from '@/modules/bankruptcy/components/request/audit-confirmation-flag-checkbox';

export default {
  name: 'DebtorForm',
  inject: ['$validator'],
  components: {
    IdentityVerificationForm,
    AuditConfirmationFlagCheckbox,
  },
  data() {
    return {
      organizedEntityTypesEnum,
      mainRequestAuditFlag,
      requestStatusEnum,
    };
  },
  computed: {
    ...mapLUTState([
      'yesNoOptions',
      'firmTypes',
      'organizedEntityTypes',
      'partyTypeDebtorClassifications',
    ]),
    ...mapState({
      formModel: state => state.debtor,
      mainRequest: state => state.mainRequest,
      auditConfirmations: state => state.auditConfirmations,
    }),
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isEditMode',
      'isNotCompleted',
    ]),
    isPerson() {
      return this.formModel.typeId == partyTypeEnum.person;
    },
    isFirmOrOrganization() {
      return this.formModel.typeId != partyTypeEnum.person;
    },
    requestObjectKey() {
      return this.$route.params.objectKey;
    },
    isIdentityFormDisabled() {
      return this.isViewMode || this.formModel.objectKey != undefined || (this.auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDetailsConfirmation}`] && this.mainRequest.statusId == requestStatusEnum.inComplete);
    },
    isCompetentParty() {
      return this.mainRequest.requestOwnerTypeId == requestOwnerTypeEnum.competentParty;
    },
    isNumberValid() {
      return this.formModel.specifiedOrganizationUnifiedNumber !== 0;
    },
    bankruptcyProofs() {
      let liquidationProcedures = [procedureTypeEnum.liquidation, procedureTypeEnum.smallDebtorsLiquidation, procedureTypeEnum.administrativeLiquidation];
      if(liquidationProcedures.includes(this.mainRequest.procedureTypeId))
      {
        return this.local.bankruptcy.debtorForm.liquidationBankruptcyProofs;
      }
      else
      {
        return this.local.bankruptcy.debtorForm.bankruptcyProofs;
      }
    },
  },
  created() {
    this.getRequestDebtorsDetails(this.requestObjectKey).then(() => {
      if (this.formModel.typeId) {
        this.getPartyTypeDebtorClassifications(this.formModel.typeId);
      }
      if (this.isCompetentParty) {
        this.$set(this.formModel, 'isSpecifiedOrganization', true);
        this.$set(this.formModel, 'isOrganizedEntity', true);
      }
    });
    this.getOrganizedEntityTypes();
    this.getFirmTypes();
  },
  methods: {
    ...mapActions([
      'getOrganizedEntityTypes',
      'getFirmTypes',
      'getPartyTypeDebtorClassifications',
      'getRequestDebtorsDetails',
    ]),
    partyTypeChangeHandler(value) {
      this.$set(this.formModel, 'firmType', undefined);
      this.$set(this.formModel, 'debtorClassificationId', undefined);
      this.getPartyTypeDebtorClassifications(value);
    },
    isOrganizedEntityChangeHandler(value) {
      if (!value) {
        this.$set(this.formModel, 'organizedEntityTypeId', undefined);
        this.$set(this.formModel, 'otherOrganizedEntityType', undefined);
      }
    },
    organizedEntityTypeChangeHandler(value) {
      if (value != organizedEntityTypesEnum.other) {
        this.$set(this.formModel, 'otherOrganizedEntityType', undefined);
      }
    },
    isSpecifiedOrganizationChangeHandler(value) {
      if (!value) {
        this.$set(this.formModel, 'specifiedOrganizationName', undefined);
      }
    },
  },
};
</script>

<style lang="scss">
</style>
